import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 30px;

  height: 80px;
`;
